import * as React from "react";
import { EDiarySessionScheduleItem, Subject } from "../../../misc/api/apiTypes";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { WebPortalClient, Visit } from "webportalclient";
import { ConfigureDiaryDeployments } from "./ConfigurationHelpers";
import * as P230Messages from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { Device, StudyScheduleSession } from "webportalclient";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

interface RemotelyConfigureP230In2itiveEDiaryProps {
    subject: Subject;
    remoteDeviceSelected: Device;
    sessionScheduleItems: StudyScheduleSession[];
    onError: (message: string) => void;
    onComplete: () => void;
}

export const RemotelyConfigureP230In2itiveEDiary = ({ subject, remoteDeviceSelected, sessionScheduleItems, onError, onComplete }: RemotelyConfigureP230In2itiveEDiaryProps) => {
    const client = useWebPortalApiClient();
    const [status, setStatus] = React.useState(P230Messages.ConfiguringDevice);

    const configure = async () => {
        const serialNumber = remoteDeviceSelected.serialNumber;

        await ConfigureDiaryDeployments(client.client, subject.Id, sessionScheduleItems, serialNumber);

        onComplete();

    }

    React.useEffect(() => {
        const remoteConfigure = () => {
            configure();
        }

        remoteConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message={status} />
        </div>
    );

}
